import React from 'react';
import { Link } from 'react-router-dom';

//HELPERS
import * as c from '../helpers/constants'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { authActionPublic } from '../store/auth';

//LAYOUT
import PublicLayout from '../layouts/public';

//COMPONENTS
import {Logo} from '../components/inspinia'
import PublicButton from '../components/publicButton';
import PublicInput from '../components/publicInput';

class RedefinirSenha extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            user: { email: '', password: '', confirmPassword: '', oldPassword: '' },
            loading: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        const byLocation = this.props.location?.state?.firstAccess === true;
        const byAuth = this.props.auth?.user?.firstAccess === true;

        if (byLocation || byAuth) {
            c.TOASTER_INFO("Você precisa redefinir sua senha antes de acessar o sistema.");
        }
    }    

    handleChange(e)
    {
        const user = this.state.user;

        this.setState({ user: { ...user, [e.target.name]: e.target.value } });
    }
    handleSubmit(e)
    {
        e.preventDefault(); if (this.state.loading) return;

        const user = this.state.user;
        if (user.email === '' || user.oldPassword === '' || user.password === '' || user.confirmPassword === '') {
            c.TOASTER_ERROR("Favor preencher todos os campos");
            return;
        }

        let url = `${c.API_BASE_URL}/users/trocaSenha`;
        
        const options = {
            method: 'POST', 
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({      
                email: user.email,
                old_password: user.oldPassword,
                password: user.password,
                confirm_password: user.confirmPassword
            })
        }

        fetch(url, options).then(async (response) => {
            this.setState({ ...this.state, loading: true });
            let json = await response.json();

            if (response.ok) {
                c.TOASTER_SUCCESS(json);

                setTimeout(function() {
                    this.props.history.push({
                        pathname: c.LOGIN_ROUTE,
                        state: { senhaRedefinida: true }
                      });                      
                }.bind(this), 1000);
                this.setState({ ...this.state, loading: false });
            } else {
                this.setState({ ...this.state, loading: false });
                c.TOASTER_ERROR(json.message);
            }
        });
    }

    render()
    {
        const user = this.state.user;

        return (
            <PublicLayout>
                <div>
                    <div className="mb-4 text-center">
                        <Logo />
                    </div>
                
                    <div className="ibox-content text-center" style={{"width": "365px", "height": "472px", "padding": "39px 33px", "borderRadius": "10px", "boxShadow": "1px 3px 10px 0 rgba(0, 0, 0, 0.3)"}}>
                        <h3 className="mt-0 fs-20 fw-600 text-body">
                            Redefina sua senha!
                        </h3>

                        <h5 className="text-muted fs-12 fw-300 mx-4 mb-5">
                            Insira o endereço de e-mail que utilizou para se inscrever e informe a senha recebida.
                        </h5>

                        <form className="form-signin m-t" onSubmit={this.handleSubmit}>
                            
                            <PublicInput type="email" name="email" placeholder="E-mail" value={user.email} required onChange={this.handleChange} img="/assets/images/user-icon.svg" />
                            
                            <PublicInput type="password" name="oldPassword" placeholder="Digite sua senha antiga" required value={user.oldPassword} onChange={this.handleChange}/>
                            <PublicInput type="password" name="password" placeholder="Digite sua nova senha" required value={user.password} onChange={this.handleChange}/>
                            <PublicInput type="password" name="confirmPassword" placeholder="Confirme sua senha" required onChange={this.handleChange}/>

                            <PublicButton type="submit" name="entrar">ENTRAR</PublicButton>
                                    
                        </form>

                    </div>
   
                    <div className="mb-0 py-4 px-0 text-left">
                        <Link to={c.LOGIN_ROUTE} className="text-light" style={{visibility: ""}}>
                            <i className="fa fa-long-arrow-left"></i> Voltar 
                        </Link>
                    </div>
                </div>

            </PublicLayout>
        );
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { auth: bindActionCreators(authActionPublic, dispatch) } };
}

export default connect(mapStateToProps, mapDispatchToProps)(RedefinirSenha);
